import * as Styles from 'layouts/PrivateLayout.styles'
import TextField from 'components/ui/TextField'
import {EmailOutlined} from '@mui/icons-material'
import {Link, useLocation} from 'react-router-dom'
import {useEffect, useState} from 'react'
import Button from 'components/ui/Button'
import {useUpdateUserMutation} from 'services/teamMembers'
import {enqueueSnackbar} from 'notistack'

interface FormErrors {
  [key: string]: string
}

const CurrentUserSettings = () => {
  const state = useLocation()
  const [user, setUser] = useState<any>({})
  const [userName, setUserName] = useState<string>('')
  const [errors, setErrors] = useState<FormErrors>({})
  const [updateUser] = useUpdateUserMutation()

  useEffect(() => {
    if (state !== null) {
      const { userData } = state.state
      setUser(userData)
      setUserName(userData?.first_name)
    }
  }, [state])

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    if (userName.length < 3) {
      setErrors({
        name: 'Enter a valid user name.'
      })
      return
    }
    const data = {
      body: {
        email: user?.email,
        name: userName
      }
    }

    try {
      const response = await updateUser(data).unwrap()
      console.log('response', response)
      enqueueSnackbar(
        'User updated successfully. Please logout to see the changes',
        {
          variant: 'success', autoHideDuration: 1000
        }
      )
    } catch (error) {
      console.error('Failed to update user:', error)
      setErrors({
        submit: 'Failed to update user. Please try again.'
      })
      enqueueSnackbar('Failed to update user. Please try again.', {
        variant: 'error', autoHideDuration: 1000
      })
    }
  }

  return (
    <div>
      <Styles.CreateEditPageTitleContainer>
        My Account
      </Styles.CreateEditPageTitleContainer>
      <form onSubmit={handleSubmit}>
        <Styles.FormColumns border-type="border">
          <Styles.FormColumnLeft>
            <Styles.FormColumnLeftDescription>
              <strong>Full name*</strong>
            </Styles.FormColumnLeftDescription>
          </Styles.FormColumnLeft>
          <Styles.FormColumnRight>
            <TextField
              id="fullName"
              required
              cc-width="full"
              label=""
              error={!!errors.name}
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              helperText={errors.name}
            ></TextField>
          </Styles.FormColumnRight>
        </Styles.FormColumns>
        <Styles.FormColumns border-type="border">
          <Styles.FormColumnLeft>
            <Styles.FormColumnLeftDescription>
              <strong>Email*</strong>
            </Styles.FormColumnLeftDescription>
          </Styles.FormColumnLeft>
          <Styles.FormColumnRight>
            <div>
              <EmailOutlined />
              <span className="pl-2">{user?.email}</span>
            </div>
          </Styles.FormColumnRight>
        </Styles.FormColumns>
        {errors.submit && (
          <Styles.FormColumns>
            <Styles.FormColumnLeft />
            <Styles.FormColumnRight>
              <div style={{ color: 'red' }}>{errors.submit}</div>
            </Styles.FormColumnRight>
          </Styles.FormColumns>
        )}
        <Styles.FormColumnsFooter>
          <Styles.FormColumnLeft />
          <Styles.FormColumnRight>
            <Styles.FormColumnsFooterButtons>
              <Link to={'/admin/dashboard'}>
                <Button>Cancel</Button>
              </Link>
              <Button
                id="updateCurrentUser"
                disabled={userName.length < 3}
                type="submit"
                cc-color="purple"
              >
                Save
              </Button>
            </Styles.FormColumnsFooterButtons>
          </Styles.FormColumnRight>
        </Styles.FormColumnsFooter>
      </form>
    </div>
  )
}

export default CurrentUserSettings
